import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetAttachmentsByPermissions = createAsyncThunk(
  "Attachments/GetAttachmentsByPermissions",
  async (attachmentModel, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Attachments/GetAttachmentsByPermissions",
        {
          applicantTypeId: attachmentModel.applicantTypeId,
          aI_ApplicationInformationId:
            attachmentModel.aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field


      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const Attachments = createSlice({
  name: "Attachments",
  initialState: {
    Attachments: [],
    loadingAttachments: false,
    errorAttachments: null,
  },
  reducers: {
    SetAttachments: (state, action) => {
      state.Attachments = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAttachmentsByPermissions.pending, (state, action) => {
        state.loadingAttachments = true;
        state.Attachments = action.payload;
        state.errorAttachments = null;
      })
      .addCase(GetAttachmentsByPermissions.fulfilled, (state, action) => {
        state.loadingAttachments = false;
        state.Attachments = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAttachmentsByPermissions.rejected, (state, action) => {
        state.loadingAttachments = false;
        state.errorAttachments = action.payload;
      });
  },
});
export const { SetAttachments } = Attachments.actions;

export default Attachments.reducer;
